import { ReferenceInput, SelectInput } from "react-admin";

import React from "react";

const UserInput = ({ ...props }) => (
  <ReferenceInput
    {...props}
    reference="users"
    filter={{ roles: ["president", "merit_evaluator"] }}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
);

export default UserInput;
